<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="stylus">
  *
    padding 0
    margin 0
  :focus
    outline none

  @font-face
    font-family: 'element-icons'
    src: url('/static/iconfont/iconfont.eot')
    src: url('/static/iconfont/iconfont.eot?#iefix') format('embedded-opentype'),
    url('/static/iconfont/iconfont.woff') format('woff'),
    url('/static/iconfont/iconfont.ttf') format('truetype'),
    url('/static/iconfont/iconfont.svg#element-icons') format('svg')

  .element-icons
    font-family "element-icons"
    font-size 16px
    font-style normal
    -webkit-font-smoothing antialiased
    -webkit-text-stroke-width 0.2px
    -moz-osx-font-smoothing grayscale

  .el-icon-account
    &:before
      content "\e6b8"

  .el-icon-gerenzhongxin
    font-size 1.4em
    &:before
      content "\e70b"

  .el-icon-password
    font-size 1.4em
    &:before
      content "\e82b"

  .el-icon-chuangkouxiala
    color #ccc
    font-size 1.4em
    &:before
      content: "\e723"

  .borderRed
    .el-input__inner
      animation a .3s ease-in
      animation-fill-mode: forwards
      +span
        animation a .3s ease-in;
        animation-fill-mode forwards

  .login
    .el-input--prefix
      .el-input__inner
        height 45px
        line-height 45px
        padding-left 40px
        border none
        background none
        border-bottom 1px solid #ccc
        border-radius 0
        color #fff
        &:focus
          border-color #fff
          -webkit-transition all .3s;
          transition all .3s;
          +span
            color #fff
            animation leftAndRight .6s ease-in
            animation-fill-mode forwards
    .el-button--primary
      background #FF3E17
      &:focus
      &:hover
        background #FF3E17
      &:active
        background #F56C6C
    .el-select
      width 100%
      .el-input.is-focus
        .el-input__inner
          border-color: #fff
      .el-input__inner
        padding-left 40px
        border-color #ccc
        background-color transparent
        border none
        border-radius 0
        border-bottom 1px solid #ccc
        color #fff
        &:focus
        &:active
          border-color #fff

  @keyframes leftAndRight
    10%
      transform rotate(20deg)
    20%
      transform rotate(-15deg)
    30%
      transform rotate(10deg)
    40%
      transform rotate(-10deg)
    50%
    100%
      transform rotate(0deg)

  @keyframes a
    10%
      transform translateY(2px)
    20%
      transform translateY(0px)
    30%
      transform translateY(-2px)
    40%
      transform translateY(0px)
    50%
      transform translateY(2px)
    100%
      transform translateY(0px)
</style>



// WEBPACK FOOTER //
// src/app.vue